/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'email-validation';
const componentName = 'email-validation-modal';
const prefix = `${moduleName}.${componentName}`;

export const sysLogTitleLabel = `${prefix}.sysLogTitleLabel`;
export const smtpTitleLabel = `${prefix}.smtpTitleLabel`;
export const emailTitleLabel = `${prefix}.emailTitleLabel`;
export const snmpTitleLabel = `${prefix}.snmpTitleLabel`;
export const snmpTextLabel = `${prefix}.snmpTextLabel`;
export const toLabel = `${prefix}.toLabel`;
export const ccLabel = `${prefix}.ccLabel`;
export const subjectLabel = `${prefix}.subjectLabel`;
export const submitLabel = `${prefix}.submitLabel`;
export const bodyLabel = `${prefix}.bodyLabel`;
export const emailInputPlaceholder = `${prefix}.emailInputPlaceholder`;
export const ccEmailInputPlaceholder = `${prefix}.ccEmailInputPlaceholder`;

export const ENGLISH = {
    [sysLogTitleLabel]: 'Validate Syslog Settings',
    [smtpTitleLabel]: 'Validate Email SMTP Settings',
    [emailTitleLabel]: 'Validate Email Settings',
    [snmpTitleLabel]: 'Validate SNMP Trap Settings',
    [snmpTextLabel]: 'Trap Description',
    [toLabel]: 'To',
    [ccLabel]: 'Cc',
    [subjectLabel]: 'Subject',
    [submitLabel]: 'Submit',
    [bodyLabel]: 'Body',
    [emailInputPlaceholder]: 'Enter Email',
    [ccEmailInputPlaceholder]: 'Enter CC Email',
};
